<div  class="content-right no-text-select">
    <div *ngIf="!isReinsured" class="content-right-blue" [@fadeIn]>
        <p>¿Qué puedes hacer desde tu Área Cliente?</p>
        <p>
            Consultar tus seguros y servicios contratados. <br> Abrir un parte y hacer su seguimiento. <br> Consultar y pagar tus recibos. <br> Modificar tus datos personales y bancarios. <br> ¡Y mucho más!
        </p>
    </div>
</div>